export default function removeNonNumericCharacters(str?: string) {
	return str?.replace(/\D/g, '') ?? '';
}
